import { createRouteRef } from '@backstage/frontend-plugin-api';

export const landingPageRouteRef = createRouteRef();

export const productMetaRouteRef = createRouteRef();
